<template>
    <div>
        <item-header-row>
            <b-col cols="8" md="8">
                {{ $t('common.products') }}
            </b-col>
            <b-col cols="4" md="4" class="flex-align-right">
                {{ $t('common.amount') }}
            </b-col>
        </item-header-row>
        <b-form-checkbox-group
            v-model="formData.itemsSelected"
            class="order-items"
        >
            <div v-for="item in mapItems(formData.itemsSelected)"
                 :key="item.sku">
                <b-card bg-variant="white" class="card-bottom">
                    <b-row class="mb-2">
                        <b-col cols="8" md="8">
                            <div class="item-combo-box">
                                <div class="flex flex-column">
                                    <span>{{ item.name }}</span><br>
                                    <span class="prod-det">{{ $t('common.listItemSku', item) }} | {{
                                            $t('common.pcs', { quantity: item.selectedQuantity })
                                        }}</span><br>
                                    <div class="item-meta">
                                        <span class="item-meta__title">{{ $t('step3.reasonLabel') }}</span>
                                        {{ reasonOptions.find(reason => reason.value === item.returnReasonType).text }}
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="4" md="4" class="flex-align-right">
                            {{
                                formatCurrency(item.priceCurrency, item.priceIncludingTax * item.selectedQuantity)
                            }}
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </b-form-checkbox-group>
    </div>
</template>
<script>
import ItemImage from "./Item/ItemImage";
import ItemHeaderRow from "./Item/ItemHeaderRow";
import {formatCurrency} from "../../services/Common";

export default {
    name: 'ConfirmList',
    components: {
        ItemImage,
        ItemHeaderRow
    },
    props: {
        formData: {},
        orderData: {},
        reasonOptions: [],
    },
    data() {
        return {}
    },
    methods: {
        formatCurrency,
        mapItems(skus) {
            return skus.map(sku => {
                return this.orderData.items.find(item => item.sku === sku);
            });
        }
    }
}
</script>
<style scoped>
.item-combo-box {
    display: grid;
    align-items: center;
}

.flex-align-right {
    display: flex;
    justify-content: flex-end;
}

.item-meta {
    color: #666666;
    font-size: 12px;
}

.item-meta__title {
    font-weight: 400;
}

.card.bg-white.card-bottom {
    border-bottom: 1px solid #e5e5e5;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.order-items div:last-child .card.bg-white.card-bottom {
    border-bottom: 0;
}
</style>
